module.exports = __webpack_public_path__ + "media/I_talk.d662f232.mp3";